import React from "react";
import "./HomeStyles/HomeSection1.scss";
import ParagraphAnimation from "../../components/TextAnimation/ParagraphAnimation";
import homesection6img from "../../assets/images/homesection1_map.png";
import NewsTicker from "../../components/NewsTicker"; 

const HomeSection1 = () => {
  return (
    <div className="home-section6">
      {/* Full screen image behind */}
      <div className="fullscreen section light-section pt-5">
      <img src={homesection6img} alt="Map" className="bg-image" />

          {/* Text overlay */}
          <div className="overlay">
            <p className="location-text">
              <ParagraphAnimation>
                <a href="https://www.ettiksoft.ch/" style={{textDecoration: "none"}}>  <span className="country">Switzerland</span> </a> • 
                <a href="https://www.ettiksoft.com/" style={{textDecoration: "none"}}><span className="country">India</span></a> • 
                <a href="https://www.ettiksoft.com/" style={{textDecoration: "none"}}><span className="country">Vietnam</span></a>
              </ParagraphAnimation>
            </p>
            <div className="main-heading">
            <p>
              <ParagraphAnimation>an engineering company.</ParagraphAnimation>
            </p>

            </div>
            
          </div>
          <div className="news-ticker-fixed">
        <NewsTicker />
      </div>

      </div>
      
      
    </div>
  );
};

export default HomeSection1;
